// extracted by mini-css-extract-plugin
module.exports = {"container":"NsTab_container_1aE9c","active":"NsTab_active_19O-e"};